<div class="modal-header">
    <h4 class="modal-title">@if (isEdit) { Update Fiscal Year Info } @else { Add Fiscal Year Info }</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
    <div class="container-fluid p-2">
        <div class="d-grid gap-3">
            <app-select-business-license class="full-width-grid-item" [(businessId)]="selectedBusinessId" [(branchId)]="selectedBranchId" [lockSelection]="lockBusiness" [displayBranchOnly]="lockBusiness" [disableNoLicenseBranch]="false"></app-select-business-license>
            <div class="form-floating w-100">
                <select class="form-select" id="year" placeholder="Fiscal Year" [(ngModel)]="fyInfo().FiscalYear" [disabled]="isEdit">
                @for (y of fiscalYears; track y) {
                    <option [value]="y">{{ y }}</option>
                }
                </select>
                <label for="year">Fiscal Year</label>
            </div>
            <hr>
            <div class="form-floating">
                <input type="number" required class="form-control" id="target" placeholder="Audit Target" [(ngModel)]="fyInfo().Amount" (focus)="$event.target.select()"/>
                <label for="target" class="form-label">Annual Target</label>
            </div>
            <div class="form-floating">
                <input type="number" required class="form-control" id="cfAdjustment" placeholder="CF Adjustment" [(ngModel)]="fyInfo().CfAdjustment" (focus)="$event.target.select()"/>
                <label for="cfAdjustment" class="form-label">CF Adjustment</label>
            </div>
        </div>
        <div class="mt-3 d-flex justify-content-end gap-2">
            <button class="btn btn-light" (click)="reset()">Reset</button>
            <button class="btn btn-primary" (click)="submit()">@if (isEdit) { Update } @else { Add }</button>
        </div>
    </div>
</div>